import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api, adminApi, getToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anonymous

  useEffect(() => {
    if (!getToken()) return setUser(false);
    adminApi("/auth/me").then(setUser).catch(() => { setToken(null); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const d = await api("/auth/login", { method: "POST", body: { email, password } });
    setToken(d.access_token);
    setUser(d.user);
  };

  const logout = async () => {
    await api("/auth/logout", { method: "POST" }).catch(() => {});
    setToken(null);
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const RequireAdmin = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="min-h-screen bg-obsidian flex items-center justify-center text-white/40 text-sm">Checking session...</div>;
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  return children;
};
